import { render } from "./EntityNavBar.vue?vue&type=template&id=05b66974&scoped=true"
import script from "./EntityNavBar.vue?vue&type=script&lang=js"
export * from "./EntityNavBar.vue?vue&type=script&lang=js"

import "./EntityNavBar.vue?vue&type=style&index=0&id=05b66974&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b66974"]])

export default __exports__